var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03516 20.9473C1.51367 20.9473 1.79688 20.6738 2.67578 19.8242L6.49414 16.0645C6.54297 16.0156 6.63086 16.0156 6.66992 16.0645L10.4883 19.8242C11.3672 20.6738 11.6504 20.9473 12.1289 20.9473C12.7832 20.9473 13.1641 20.5176 13.1641 19.7559V2.80273C13.1641 0.947266 12.2363 0 10.4004 0H2.76367C0.927734 0 0 0.947266 0 2.80273V19.7559C0 20.5176 0.380859 20.9473 1.03516 20.9473ZM1.83594 18.3105C1.69922 18.4473 1.54297 18.4082 1.54297 18.2129V2.82227C1.54297 1.98242 1.98242 1.54297 2.8418 1.54297H10.332C11.1816 1.54297 11.6211 1.98242 11.6211 2.82227V18.2129C11.6211 18.4082 11.4746 18.4473 11.3281 18.3105L7.09961 14.209C6.78711 13.9062 6.37695 13.9062 6.06445 14.209L1.83594 18.3105Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmark_icon.6de9040ad0b012a9b347ec6500b34cdc.svg";
export { ForwardRef as ReactComponent };